/**
 * Post Carousel — a horizontal strip of post cards with prev/next controls.
 *
 * Three changes from the prototype's script:
 *
 *  - It binds to every `.post-carousel` on the page instead of the ids
 *    `pbTrack` / `pbPrev` / `pbNext`, so two of these blocks on one page do
 *    not drive each other.
 *  - Cards outside the current window get `inert`. The viewport is
 *    `overflow: hidden`, so without it a keyboard user tabs into a card
 *    they cannot see and the browser scrolls the container to reveal it,
 *    which fights the transform and leaves the track mid-card.
 *  - It honours prefers-reduced-motion. The CSS drops the transition, and
 *    the arrows still work, so the position stays correct either way.
 *
 * `perView` has to agree with the breakpoints in
 * src/sass/blocks/_post-carousel.scss or the track lands mid-card.
 *
 * No optional chaining or nullish coalescing: gulp-babel has no preset
 * configured, so uglify-js parses this as written.
 */
(function () {
  const blocks = document.querySelectorAll(".post-carousel");
  if (!blocks.length) return;
  function setup(root) {
    const track = root.querySelector(".pcar-track");
    const prev = root.querySelector(".pcar-prev");
    const next = root.querySelector(".pcar-next");
    const fill = root.querySelector(".pcar-fill");
    if (!track || !prev || !next) return;
    const cards = track.children;
    if (!cards.length) return;
    let index = 0;
    function perView() {
      const w = window.innerWidth;
      if (w <= 620) return 1;
      if (w <= 900) return 2;
      return 3;
    }
    function maxIndex() {
      return Math.max(0, cards.length - perView());
    }
    function apply() {
      const pv = perView();
      const max = maxIndex();
      if (index > max) index = max;
      const first = cards[0];
      if (!first) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 18;
      const step = first.getBoundingClientRect().width + gap;
      track.style.transform = "translate3d(" + -index * step + "px,0,0)";
      prev.disabled = index === 0;
      next.disabled = index >= max;

      // Keep what is off-screen out of the tab order. `inert` is ignored by
      // browsers that do not support it, which leaves the prototype's
      // behaviour rather than breaking anything.
      for (let i = 0; i < cards.length; i++) {
        const visible = i >= index && i < index + pv;
        if (visible) {
          cards[i].removeAttribute("inert");
        } else {
          cards[i].setAttribute("inert", "");
        }
      }
      if (fill) {
        const pct = Math.min(100, pv / cards.length * 100);
        fill.style.width = pct + "%";
        const travel = max === 0 ? 0 : index / max * (100 - pct);
        fill.style.transform = "translateX(" + travel / (pct / 100) + "%)";
      }
    }
    prev.addEventListener("click", function () {
      index = Math.max(0, index - 1);
      apply();
    });
    next.addEventListener("click", function () {
      index = Math.min(maxIndex(), index + 1);
      apply();
    });
    let resizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 120);
    });
    apply();
  }
  for (let i = 0; i < blocks.length; i++) {
    setup(blocks[i]);
  }
})();